import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import {
  Fields,
  defaultValues,
  prepareInput,
} from 'app/src/elements/hookForms';

import SPECIAL_USES from './specialUses';
import { CREATE_ACCOUNT } from './queries';

export const FIELDS = {
  name: {
    rules: { required: true },
  },
  accountGroupId: {
    label: 'Account Group',
    rules: { required: true }
  },
  parentId: {
    label: 'Parent',
    blank: 'null',
  },
  special: {
    label: 'Special Use Designation',
    select: SPECIAL_USES,
    hint: (
      'In most cases, this can be left blank. It is used to identify ' +
      'accounts that have special back-end uses.'
    ),
    blank: 'null',
  },
  nextCheckNumber: {
    type: 'int',
    blank: 'null',
  },
};

const NewAccount = ({ setShowModal, refetch, selects }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createAccount] = useMutation(CREATE_ACCOUNT, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    createAccount({ variables: prepareInput(input, FIELDS) });
  });

  const fields = { ...FIELDS };
  fields.accountGroupId.select = selects.accountsWithCount.accountGroups;

  if (selects) {
    fields.parentId.select =
      selects.accountsWithCount.entries
      .map(entry => ({ value: entry.id, label: entry.fullName }));
  }

  return (
    <View>
      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      <ButtonGroup>
        <Button label="Create Account" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default NewAccount;
